import { FiArrowLeft, FiCreditCard } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/signin"
          className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-500 mb-6"
        >
          <FiArrowLeft className="mr-2 h-4 w-4" />
          Back to Sign In
        </Link>

        <div className="bg-white rounded-2xl p-8 card-shadow border border-gray-100">
          <h1 className="text-3xl font-bold text-gray-900 inline-flex items-center">
            <FiCreditCard className="mr-3 h-7 w-7 text-orange-500" />
            Refund &amp; Cancellation Policy
          </h1>
          <p className="mt-2 text-sm text-gray-500">
            How cancellations and refunds work for paid membership subscriptions on UsedAdda, operated by MK WHEELS LLP.
          </p>
          <p className="mt-1 text-xs text-gray-500">Last updated: 24 June 2026</p>

          <div className="mt-8 space-y-6 text-sm text-gray-700 leading-7">
            <p>
              This policy explains how cancellations and refunds work for paid membership subscriptions on the
              UsedAdda Seller app, operated by MK WHEELS LLP. The Basic plan is free and is not subject to billing.
            </p>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">1. Subscription and Billing</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Paid plans (such as Pro and Premium) are billed in Indian Rupees (INR).</li>
                <li>You may choose a billing cycle such as monthly, quarterly, or annually where available.</li>
                <li>Payments may be processed through supported methods such as card, UPI, net banking, or wallet via our payment partners.</li>
                <li>Applicable taxes may be added as required by law.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">2. Cancellation</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>You can cancel your paid membership at any time from within the app or by contacting support.</li>
                <li>When you cancel, your plan remains active until the end of the current billing cycle; it simply does not renew afterwards.</li>
                <li>Where auto-renewal is enabled, turning it off stops future charges.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">3. Refund Eligibility</h2>
              <p className="mt-2">
                Membership subscriptions provide access to digital features that become available immediately upon
                activation. As a result, subscription fees are generally non-refundable once the billing period has
                started. Refunds may be considered in the following cases:
              </p>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Duplicate charges or amounts debited more than once for the same plan.</li>
                <li>Amounts debited where the plan was not activated due to a verified technical error.</li>
                <li>Cases required to be refunded under applicable consumer law.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">4. How to Request a Refund</h2>
              <p className="mt-2">
                To request a refund, email{' '}
                <a href="mailto:support@usedadda.com" className="text-orange-600 hover:text-orange-500 font-medium">
                  support@usedadda.com
                </a>{' '}
                from your registered email address within 7 days of the charge. Include your account details, plan
                name, and the payment/transaction ID. Approved refunds are processed to the original payment method,
                typically within 5&ndash;7 business days after approval (your bank may take additional time to reflect it).
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">5. Failed or Pending Transactions</h2>
              <p className="mt-2">
                If an amount is debited but your plan is not activated, do not pay again. Contact support with the
                transaction details. Verified failed transactions are either credited back or the plan is activated,
                at your preference where possible.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">6. Non-Refundable Cases</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Partial use of a billing period after the plan was activated and used.</li>
                <li>Change of mind after a billing period has started, except where required by law.</li>
                <li>Violations of our Terms &amp; Conditions that result in account suspension.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">7. Changes to Plans and Pricing</h2>
              <p className="mt-2">
                We may change plan features and pricing from time to time. Changes apply to future billing cycles and
                will be communicated within the app or by email.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">8. Business and Contact for Billing and Refunds</h2>
              <div className="mt-2 rounded-xl bg-orange-50 border border-orange-100 p-4 space-y-1 text-gray-800">
                <p><span className="font-semibold">Business Name:</span> MK WHEELS LLP</p>
                <p><span className="font-semibold">Product:</span> UsedAdda</p>
                <p><span className="font-semibold">Address:</span> 12-71/7342, NEHRU NAGAR, Near BIT-1, Eluru, Andhra Pradesh, 534001</p>
                <p><span className="font-semibold">Email:</span> support@usedadda.com</p>
                <p><span className="font-semibold">Website:</span> usedadda.com</p>
              </div>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100 flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="font-medium text-orange-600 hover:text-orange-500">About Us</Link>
            <Link to="/policies" className="font-medium text-orange-600 hover:text-orange-500">Policies</Link>
            <Link to="/terms-and-conditions" className="font-medium text-orange-600 hover:text-orange-500">Terms &amp; Conditions</Link>
            <Link to="/contact" className="font-medium text-orange-600 hover:text-orange-500">Contact Details</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
